import { Grid, Typography } from "@mui/material";

import { CardItem } from "@/components/Delivery/CreateDeliveryDeal/ui/card-item";
import CustomCard from "@/components/Delivery/CreateDeliveryDeal/ui/custom-card";
import { getDurationParts, getRepresentativeLabel } from "@/utils/delivery-display";
import type { Delivery } from "./types";

type DeliveryDetailsCardProps = {
  delivery: Delivery;
};

export function DeliveryDetailsCard({ delivery }: DeliveryDetailsCardProps) {
  const { hours: durationHours, minutes: durationMinutes } = getDurationParts(delivery.duration);
  const representativeLabel = getRepresentativeLabel(delivery);

  return (
    <CustomCard label="Détails de la livraison">
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 3 }}>
          <CardItem label="Contrat N°" icon="📄">
            <Typography sx={{ fontWeight: 700, color: "primary.main", fontSize: "1rem" }}>
              <span style={{ fontSize: "10px", color: "grey" }}>#</span>
              {delivery.id}
            </Typography>
          </CardItem>
        </Grid>

        <Grid size={{ xs: 12, sm: 3 }}>
          <CardItem label="🛣️ Distance">
            <Typography sx={{ fontWeight: 700, color: "primary.main", fontSize: "1.25rem" }}>
              {new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2 }).format(
                delivery.distance
              )}
              <Typography
                component="span"
                sx={{ fontSize: "0.9rem", ml: 0.5, color: "text.secondary" }}
              >
                km
              </Typography>
            </Typography>
          </CardItem>
        </Grid>

        <Grid size={{ xs: 12, sm: 3 }}>
          <CardItem label="⏱️ Durée estimée">
            <Typography sx={{ fontWeight: 700, color: "primary.main", fontSize: "1.25rem" }}>
              {new Intl.NumberFormat("fr-FR").format(durationHours)}
              <Typography
                component="span"
                sx={{ fontSize: "0.9rem", ml: 0.5, color: "text.secondary" }}
              >
                h
              </Typography>
              {durationMinutes !== 0 ? (
                <>
                  {" "}
                  {new Intl.NumberFormat("fr-FR").format(durationMinutes)}
                  <Typography
                    component="span"
                    sx={{ fontSize: "0.9rem", ml: 0.5, color: "text.secondary" }}
                  >
                    m
                  </Typography>
                </>
              ) : null}
            </Typography>
          </CardItem>
        </Grid>

        <Grid size={{ xs: 12, sm: 3 }}>
          <CardItem label="🚚 Mandataire">
            <Typography sx={{ fontWeight: 700, color: "primary.main", fontSize: "1rem" }}>
              {representativeLabel}
            </Typography>
          </CardItem>
        </Grid>
      </Grid>
    </CustomCard>
  );
}
